// eslint-disable-next-line no-unused-vars
import React, { useEffect } from 'react';

const SEO = ({ pathname = '/' }) => {
  // Default metadata
  let title = 'Clarity Impact Finance';
  let description = 'Expert financial consulting and services for impact-focused organizations.';
  
  // Page-specific metadata based on pathname
  switch(pathname) {
    case '/':
      title = 'Clarity Impact Finance | Home';
      break;
    case '/login':
      title = 'Clarity Impact Finance | Login';
      description = 'Log in to access your Clarity Impact Finance client portal.';
      break;
    case '/admin':
      title = 'Clarity Impact Finance | Admin Panel';
      description = 'Administrative dashboard for Clarity Impact Finance.';
      break;
    case '/client-resources':
      title = 'Clarity Impact Finance | Client Resources';
      description = 'Access exclusive resources for Clarity Impact Finance clients.';
      break;
    case '/terms-conditions':
      title = 'Clarity Impact Finance | Terms & Conditions';
      description = 'Terms and conditions for using Clarity Impact Finance services.';
      break;
    default:
      if (pathname.startsWith('/article/')) {
        title = 'Clarity Impact Finance | Article';
        description = 'Insights and articles from Clarity Impact Finance.';
      }
  }
  
  useEffect(() => {
    // Check for browser environment before modifying DOM
    if (typeof document === 'undefined') return;
    
    // Update document title
    document.title = title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      metaDescription.content = description;
      document.head.appendChild(metaDescription);
    }
    
    // Update og:title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    } else {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      ogTitle.setAttribute('content', title);
      document.head.appendChild(ogTitle);
    }
    
    // Update og:description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    } else {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      ogDescription.setAttribute('content', description);
      document.head.appendChild(ogDescription);
    }
  }, [title, description, pathname]);
  
  // No rendering needed as we're just updating the document head
  return null;
};

export default SEO;
